import Enum from "../../../enums/Enum";

const DirectBillingItemAuthorizationStatusEnum = new Enum({
    AUTHORIZED: {name: "Authorized"},
    REJECTED: {name: "Rejected"}
});

export default DirectBillingItemAuthorizationStatusEnum;